"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationStatusMapping = void 0;

var IntegrationStatusMapping =
/** @class */
function () {
  function IntegrationStatusMapping(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - salesforceEventSettingId
   * @param string? - statusMappingType salesforce-campaign-member
   * @return Promise|Observable|any
   */


  IntegrationStatusMapping.prototype.ListStatusMappingsForSalesforceEventSetting = function (salesforceEventSettingId, statusMappingType) {
    if (statusMappingType === void 0) {
      statusMappingType = null;
    }

    return this.restClient.get('IntegrationStatusMapping/UseCase/ListStatusMappingsForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId,
      statusMappingType: statusMappingType
    });
  }; // Commands

  /**
   * @param string - statusMappingType salesforce-campaign-member
   * @param string - integrationSettingType salesforce|marketo
   * @param string - integrationSettingId
   * @param string - statusId assigned|purchased|confirmed-by-rsvp|declined-by-rsvp|left-behind|not-yet-purchased|registered|unconfirmed|recycled|not-yet-registered|waitlisted|checked-in
   * @param string - integrationStatusName
   * @return Promise|Observable|any
   */


  IntegrationStatusMapping.prototype.CreateIntegrationStatusMapping = function (statusMappingType, integrationSettingType, integrationSettingId, statusId, integrationStatusName) {
    return this.restClient.post('IntegrationStatusMapping/UseCase/CreateIntegrationStatusMapping', {
      statusMappingType: statusMappingType,
      integrationSettingType: integrationSettingType,
      integrationSettingId: integrationSettingId,
      statusId: statusId,
      integrationStatusName: integrationStatusName
    });
  };
  /**
   * @param string - integrationStatusMappingId
   * @param string - statusId assigned|purchased|confirmed-by-rsvp|declined-by-rsvp|left-behind|not-yet-purchased|registered|unconfirmed|recycled|not-yet-registered|waitlisted|checked-in
   * @return Promise|Observable|any
   */


  IntegrationStatusMapping.prototype.SetIntegrationStatusMappingStatusId = function (integrationStatusMappingId, statusId) {
    return this.restClient.post('IntegrationStatusMapping/UseCase/SetIntegrationStatusMappingStatusId', {
      integrationStatusMappingId: integrationStatusMappingId,
      statusId: statusId
    });
  };
  /**
   * @param string - integrationStatusMappingId
   * @param string - integrationStatusValue
   * @return Promise|Observable|any
   */


  IntegrationStatusMapping.prototype.SetIntegrationStatusMappingValue = function (integrationStatusMappingId, integrationStatusValue) {
    return this.restClient.post('IntegrationStatusMapping/UseCase/SetIntegrationStatusMappingValue', {
      integrationStatusMappingId: integrationStatusMappingId,
      integrationStatusValue: integrationStatusValue
    });
  };

  return IntegrationStatusMapping;
}();

exports.IntegrationStatusMapping = IntegrationStatusMapping;